import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthRequest = error.config?.url?.startsWith('/auth/')
    if ([401, 403].includes(error.response?.status) && !isAuthRequest) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const authAPI = {
  getGoogleAuthUrl: () => api.get('/auth/google/url'),
  googleCallback: (code) => api.post('/auth/google/callback', { code }),
  verify: () => api.get('/auth/verify'),
  logout: () => api.post('/auth/logout'),
}

// Gmail API
export const gmailAPI = {
  getDrafts: () => api.get('/gmail/drafts'),
  getDraft: (draftId) => api.get(`/gmail/drafts/${draftId}`),
  sendDemo: (data) => api.post('/gmail/send-demo', data),
  sendBulk: (data) => api.post('/gmail/send-bulk', data),
  getJob: (jobId) => api.get(`/gmail/jobs/${jobId}`),
  preview: (data) => api.post('/gmail/preview', data),
  cancelCampaign: (campaignId) => api.post(`/gmail/cancel-campaign/${campaignId}`),
}

export const campaignsAPI = {
  list: () => api.get('/campaigns'),
  getById: (campaignId) => api.get(`/campaigns/${campaignId}`),
  save: (data) => api.post('/campaigns', data),
  uploadAsset: (data) => api.post('/campaigns/assets', data),
  deleteAsset: (data) => api.delete('/campaigns/assets', { data }),
  sendDemo: (campaignId) => api.post(`/campaigns/${campaignId}/send-demo`),
  approve: (campaignId) => api.post(`/campaigns/${campaignId}/approve`),
  getJob: (campaignId, jobId) => api.get(`/campaigns/${campaignId}/jobs/${jobId}`),
  cancel: (campaignId) => api.post(`/campaigns/${campaignId}/cancel`),
  updateSettings: (campaignId, data) => api.patch(`/campaigns/${campaignId}/settings`, data),
  deactivate: (campaignId) => api.patch(`/campaigns/${campaignId}/deactivate`),
  delete: (campaignId) => api.delete(`/campaigns/${campaignId}`)
}

// Legacy mail-merge screen API
export const emailAPI = {
  getLogs: (params) => api.get('/emails/logs', { params }),
  getStats: () => api.get('/emails/stats'),
  sendDemo: (data) => api.post('/gmail/send-demo', data),
  sendBulk: (data) => api.post('/gmail/send-bulk', data),
  getJob: (jobId) => api.get(`/gmail/jobs/${jobId}`),
  cancelCampaign: (jobId) => api.post(`/gmail/cancel-campaign/${jobId}`)
}

export const usersAPI = {
  list: () => api.get('/users'),
  add: (data) => api.post('/users', data),
  update: (email, data) => api.patch(`/users/${encodeURIComponent(email)}`, data),
  delete: (email) => api.delete(`/users/${encodeURIComponent(email)}`)
}

export const templatesAPI = {
  list: () => api.get('/templates'),
  getById: (templateId) => api.get(`/templates/${encodeURIComponent(templateId)}`),
  create: (data) => api.post('/templates', data),
  update: (templateId, data) => api.patch(`/templates/${encodeURIComponent(templateId)}`, data),
  delete: (templateId) => api.delete(`/templates/${encodeURIComponent(templateId)}`)
}

export default api
